import React, { Component } from 'react'
import styled from 'styled-components'
import theme from 'ui/styles/theme'
import easing from 'ui/styles/easing'

const TransitionPath = styled.path`
  transition: fill 0.3s ${easing.easeOutCubic};
`

export default class IconCapacitive extends Component {
  render() {
    const { hover, active } = this.props
    
    return (
      <svg
        width="57"
        height="58"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <path
            id="a"
            d="M0 57.466h56.492V0H0z"
          />
        </defs>
        <g
          fill="none"
          fillRule="evenodd"
        >
          <TransitionPath
            fill={hover || active ? theme.colors.primary : theme.colors.secondary}
            d="M7.641 13.636a5.98 5.98 0 0 1-4.24-1.754l-.479-.478.957-.958.48.479a4.649 4.649 0 0 0 6.566 0 4.65 4.65 0 0 0 0-6.567l-.479-.478.957-.958.48.479a6.004 6.004 0 0 1 0 8.481 5.979 5.979 0 0 1-4.242 1.754"
          />
          <TransitionPath
            fill={hover || active ? theme.colors.primary : theme.colors.secondary}
            d="M7.533 17.532a9.932 9.932 0 0 1-7.07-2.929L0 14.14l.927-.927.463.463a8.631 8.631 0 0 0 6.143 2.545 8.63 8.63 0 0 0 6.143-2.545 8.628 8.628 0 0 0 2.545-6.142c0-2.321-.904-4.503-2.545-6.144l-.463-.463L14.14 0l.463.464a9.933 9.933 0 0 1 2.929 7.07c0 2.67-1.04 5.181-2.929 7.07a9.931 9.931 0 0 1-7.07 2.928"
          />
          <TransitionPath
            fill={hover || active ? theme.colors.primary : theme.colors.secondary}
            d="M21.428 39.934h.974V18.506h-.974zM36.038 39.934h.974V18.506h-.974zM29.22 20.454h.974V6.818h-.974zM26.298 18.506h.974v-6.818h-.974zM32.142 18.506h.974v-6.818h-.974z"
          />
          <TransitionPath
            fill={hover || active ? theme.colors.primary : theme.colors.secondary}
            d="M30.194 44.804l-7.792-4.55.591-1.294 7.201 4.204 7.201-4.204.591 1.294zM30.194 38.96l-7.792-4.55.591-1.294 7.201 4.205 7.201-4.205.591 1.294zM30.194 33.116l-7.792-4.55.591-1.294 7.201 4.204 7.201-4.204.591 1.294zM30.194 26.298l-7.792-4.55.591-1.294 7.201 4.204 7.201-4.204.591 1.294z"
          />
          <TransitionPath
            fill={hover || active ? theme.colors.primary : theme.colors.secondary}
            d="M29.22 52.596h.974V24.35h-.974z"
          />
          <TransitionPath
            fill={hover || active ? theme.colors.primary : theme.colors.secondary}
            d="M56.492 37.986h-6.998v1.334h5.238l-4.88 16.811H10.539L5.671 39.854h4.906v-1.335H3.896l5.666 18.947h41.275z"
          />
        </g>
      </svg>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/ProductsNew/IconCapacitive.js